import { FC, ButtonHTMLAttributes, ReactNode } from 'react'
import { useTheme } from '@emotion/react'

// styles
import { styles } from './styles'

interface ButtonSmallProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  appearance?: 'primary' | 'secondary'
  children: ReactNode
}

export const ButtonSmall: FC<ButtonSmallProps> = ({
  appearance = 'primary',
  children,
  ...attributes
}) => {
  const theme = useTheme()

  return (
    <button
      css={[
        styles(theme).button.shared,
        appearance === 'primary' && styles(theme).button.primary,
        appearance === 'secondary' && styles(theme).button.secondary,
        attributes.disabled && styles(theme).button.disabled,
      ]}
      type="button"
      {...attributes}
    >
      {children}
    </button>
  )
}
